export default function IceHockeyIcon() {
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true">
      <rect x="3" y="8" width="58" height="48" rx="16" fill="#E7F3FB" stroke="#F2C230" strokeWidth="3" />
      <rect x="30" y="9.5" width="4" height="45" fill="#D7263D" />
      <rect x="17" y="9.5" width="3.5" height="45" fill="#2F6FD6" opacity="0.85" />
      <rect x="43.5" y="9.5" width="3.5" height="45" fill="#2F6FD6" opacity="0.85" />
      <path d="M58 24h-6v16h6" fill="none" stroke="#E02B3E" strokeWidth="2.6" strokeLinejoin="round" />
      <g transform="rotate(-32 26 34)">
        <rect x="23.5" y="6" width="5" height="34" rx="2" fill="#2B2F36" />
        <rect x="24.2" y="12" width="3.6" height="9" fill="#2F8BFF" />
        <path d="M23.5 38h5v4c0 2-1 3-3 3H11c-2 0-3-1.2-3-3s1.2-3 3-3h12.5z" fill="#14171C" />
      </g>
      <path d="M38 36l9-4M36 41l11-2" stroke="#FF8A1F" strokeWidth="2.4" strokeLinecap="round" opacity="0.8" />
      <ellipse cx="48" cy="34" rx="6.5" ry="5" fill="#0B0D10" />
      <ellipse cx="48" cy="32.5" rx="6.5" ry="3.6" fill="#2B2F36" />
    </svg>
  );
}
